import ProfileHeader from "./ProfileHeader";
import ProfileSummary from "./ProfileSummary";
import InsideHeader from "../../components/InsideHeader";
import "./profile.css";

export default function MainProfile() {
  return (
    <div className="profile-page">
      <InsideHeader
        title="My Profile"
        subtitle="Manage your profile details here"
        back={false}
      />
      <div className="profile-page-body">
        <ProfileHeader />
        <ProfileSummary />
      </div>
    </div>
  );
}
